{
  "version": 1,
  "asset_id": "63fd1c17-7bd3-41d3-ae64-4dcefe3f4b1f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/63fd1c17-7bd3-41d3-ae64-4dcefe3f4b1f/hiatal-type-3-second-en-1122.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/63fd1c17-7bd3-41d3-ae64-4dcefe3f4b1f/hiatal-type-3-second-en-1122.webp",
  "original_filename": "hiatal-type-3-second-en-1122.webp",
  "size": 114508,
  "content_type": "image/webp",
  "created_at": "2026-09-26T23:53:29Z"
}
